import { useState } from "react";
import { Dialog } from "../ui/Dialog";

/** auto_annotate_dialog.ClassResolutionDialog: create each missing class, or fold it onto an existing one. */
export function ClassResolutionDialog({ missing, projectClasses, suggestions, onCancel, onImport }: {
  missing: string[]; projectClasses: string[]; suggestions: Record<string, string>;
  onCancel: () => void; onImport: (mapping: Record<string, string>) => void;
}) {
  const [choice, setChoice] = useState<Record<string, string>>(() =>
    Object.fromEntries(missing.map((m) => [m, projectClasses.includes(suggestions[m]) ? suggestions[m] : ""])));
  return (
    <Dialog title="Resolve Classes" onClose={onCancel} width={520} testId="resolve-classes">
      <p style={{ marginTop: 0 }}>
        This model predicts classes the project does not have under these exact names. Create each as a new class,
        or map it onto an existing one — future predictions with this name will land there too.
      </p>
      {missing.map((name) => (
        <div key={name} style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
          <span style={{ minWidth: 120 }}>{name}</span>
          <select className="select" value={choice[name]} onChange={(e) => setChoice({ ...choice, [name]: e.target.value })} data-testid={`map-${name}`}>
            <option value="">Create new class</option>
            {projectClasses.map((pc) => <option key={pc} value={pc}>{`Merge into '${pc}'`}</option>)}
          </select>
        </div>
      ))}
      <div className="dialog-actions">
        <button className="btn" onClick={onCancel}>Cancel</button>
        <button className="btn primary" data-testid="resolve-import"
          onClick={() => onImport(Object.fromEntries(Object.entries(choice).filter(([, v]) => v)))}>Import</button>
      </div>
    </Dialog>
  );
}
